import React from 'react';
import './Button.css';
import Unit from './Modular/Unit';
import type { UnitSettings, As } from './Modular/ModularTypes/UnitSettings';

// Atomic Component: Button
type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'outline'
  | 'outlinelight'
  | 'carousel'
  | 'signup'
  | 'authSecondary';

type ButtonIntent = '' | 'submit' | 'cancel' | 'danger';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  intent?: ButtonIntent | string;
  ariaLabel?: string;
  disabled?: boolean;
  tabIndex?: number;
  className?: string;
  width?: '1' | '2' | '3' | '4' | '5' | '6' | '7';
  height?: '1' | '2';
  widthMin?: '40' | '50' | '70';
  heightMin?: string;
  position?: 'absolute';
  positionRight?: '0' | '1' | '2';
  positionTop?: '0' | '1' | '2' | '3' | '4';
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary', // visual intent
  intent = '', // semantic intent: 'submit' | 'cancel' | 'danger'
  ariaLabel,
  disabled = false,
  tabIndex = 0,
  className = '',
  widthMin,
  width,
  height,
  position,
  positionRight,
  positionTop,
}) => {
  const baseStyles = 'btn-base';
  const variantStyles: Record<ButtonVariant, string> = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline',
    outlinelight: 'btn-outline-light',
    carousel: 'btn-carousel',
    signup: 'btn-signup',
    authSecondary: 'btn-auth-secondary',
  };

  return (
    <Unit
      as={'button'}
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
      tabIndex={tabIndex}
      className={`${baseStyles} ${variantStyles[variant]} intent-${intent} ${className} `.trim()}
      widthMin={widthMin}
      width={width}
      height={height}
      position={position}
      positionRight={positionRight}
      positionTop={positionTop}
    >
      {children}
    </Unit>
  );
};

export default Button;

// Wrapper: ButtonGroup (context-aware layout container)
// export const ButtonGroup = ({ children, layout, className = '' }) => {
//   const layoutClass =
//     layout === 'grid' ? 'button-group-grid' : 'button-group-flex';

//   return (
//     <div
//       className={`button-group ${layoutClass} ${className}`.trim()}
//       role="group"
//     >
//       {children}
//     </div>
//   );
// };
